export const routes = {
  VerificationAccountHome: '/verification-account/',
}
